import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@portals/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs';
import { Comment } from '@portals/api';

@Component({
	selector: 'portals-comment',
	templateUrl: './comment.component.html',
	styleUrls: ['./comment.component.scss'],
})
export class CommentComponent extends BaseComponent implements AfterViewInit {
	@Input() comments: Array<Comment> = [];
	@Output() commentAdded = new EventEmitter<string>();
	@Output() showNotification = new EventEmitter<any>();
	@ViewChild('autosize', { static: false }) autosize!: CdkTextareaAutosize;
	@ViewChild('scrollframe', { static: false }) scrollFrame!: ElementRef;
	@ViewChild('target', { static: false }) target!: ElementRef;
	@ViewChildren('item') itemElements!: QueryList<any>;

	form = new FormGroup({
		comment: new FormControl('', Validators.required),
	});

	private scrollContainer: any;
	private isNearBottom = true;

	constructor(private _ngZone: NgZone) {
		super();
	}

	async ngAfterViewInit() {
		this.scrollContainer = await this.scrollFrame?.nativeElement;
		this.itemElements.changes.subscribe((_) => this.onItemElementsChanged());
		this.scrollToBottom();
	}

	addComment() {
		const comment = this.form.get('comment')!.value as string;

		this.commentAdded.emit(comment);
		this.form.reset({ comment: '' });
	}

	triggerResize() {
		// Wait for changes to be applied, then trigger textarea resize.
		this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
	}

	private onItemElementsChanged(): void {
		if (this.isNearBottom) {
			this.scrollToBottom();
		}
	}

	private scrollToBottom(): void {
		this.scrollContainer?.scroll({
			top: this.scrollContainer.scrollHeight,
			left: 0,
			behavior: 'auto',
		});
	}

	private isUserNearBottom(): boolean {
		const threshold = 150;
		const position = this.scrollContainer.scrollTop + this.scrollContainer.offsetHeight;
		const height = this.scrollContainer.scrollHeight;
		return position > height - threshold;
	}

	scrolled(event: any): void {
		this.isNearBottom = this.isUserNearBottom();
	}
}
